import AdminLayout from '../../components/templates/layout/AdminLayout';
import TierManagement from '../../components/templates/admin/TierManagement';

const TierManagementPage = () => {
  return (
    <AdminLayout>
      <TierManagement />
    </AdminLayout>
  );
};

export default TierManagementPage;
